import styled from 'styled-components';

export const ProductInfoImageContainer = styled.div`
  img {
    width: 100%;
  }

  padding: 10px 0;
`;
export const InfoImage = styled.div`
  margin-top: ${(props) => (props.negativeMargin ? '-4px' : 'unset')};
  position: relative;
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '75%')};
`;
